import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { matchPath } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { FileTextOutlined, MailOutlined, QrcodeOutlined } from '@ant-design/icons';

import { collapseSidebar } from '../../../../redux/actions/config';

const { Content, Sider } = Layout;
const MenuItem = Menu.Item;

const DSPage = (props) => {
  const dispatch = useDispatch();
  const { children, location } = props;
  const collapsed = useSelector((state) => state.config.isSidebarCollapsed);
  const match = matchPath(location.pathname, {
    path: '/dashboard/:projectId/:dashboardMode/:dashboardPage',
    exact: true,
    strict: false,
  });
  const { projectId } = match ? match.params : {};

  return (
    <Layout>
      <Sider collapsible collapsed={collapsed} onCollapse={() => dispatch(collapseSidebar(!collapsed))}>
        <div className="logo" />
        <Menu selectedKeys={[location.pathname]} mode="inline">
          <MenuItem key={`/dashboard/${projectId}/ds/summary`}>
            <NavLink to={`/dashboard/${projectId}/ds/summary`}>
              <FileTextOutlined />
              <span>Summary</span>
            </NavLink>
          </MenuItem>
          <MenuItem key={`/dashboard/${projectId}/ds/tickets`}>
            <NavLink to={`/dashboard/${projectId}/ds/tickets`}>
              <MailOutlined />
              <span>Tickets</span>
            </NavLink>
          </MenuItem>
          <MenuItem key={`/dashboard/${projectId}/ds/qr-stickers`}>
            <NavLink to={`/dashboard/${projectId}/ds/qr-stickers`}>
              <QrcodeOutlined />
              <span>QR Stickers</span>
            </NavLink>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout>
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default DSPage;
